import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col } from 'reactstrap';
import Select from "react-select";
import { useTranslation } from "react-i18next";
import axios from 'axios';
import CompDtMoneyTransferChannels from '../../Components/MoneyTransfer/CompDtMoneyTransferChannels';
import { ToastContainer, toast } from 'react-toastify';
import { useParams, useNavigate } from "react-router-dom";


function CompMoneyTransferChannels({ moneyTransferId }) {
    const { t } = useTranslation();
    const [componentId] = useState('compMoneyTransferChannels');
    const [data, setData] = useState([]);
    const [dataMoneyTransferChannels, setDataMoneyTransferChannels] = useState(null);
    const [dataLocked, setDataLocked] = useState(true);
    const [logged, setLogged] = useState(false);
    const [seed, setSeed] = useState(0);

    const params = useParams();
    let letMoneyTransferId = moneyTransferId;
    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (letMoneyTransferId && letMoneyTransferId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/finance/back-office/money-transfer-channel/' + letMoneyTransferId + '/find-and-list')
                    .then(response => {
                        setDataMoneyTransferChannels(response?.data?.payload);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, letMoneyTransferId]);


    return (
        <React.Fragment>
            <ToastContainer />

            <Row className="mt-3 mb-3">
                <Col className={"col-md-12"}>
                    <CompDtMoneyTransferChannels items={dataMoneyTransferChannels} />
                    <br />
                </Col>
            </Row>

        </React.Fragment>
    );
}
export default CompMoneyTransferChannels;